import * as React from 'react';
import CreateSvgIcon from '../components/CreateSvgIcon';
import { registerIcons } from '@uifabric/styling/lib/utilities/icons';

const RewardsFilled = CreateSvgIcon({
    Svg: props => (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            {...props}
            xmlns="http://www.w3.org/2000/svg">
            <path d="M18.25 -0.000488281C19.2165 -0.000488281 20 0.783013 20 1.74951V4.79222C20 5.81638 19.4309 6.75569 18.5231 7.2298L12.223 10.5203C13.869 11.3386 15 13.0373 15 15.0001C15 17.7615 12.7614 20.0001 10 20.0001C7.23858 20.0001 5 17.7615 5 15.0001C5 13.0373 6.13104 11.3386 7.77695 10.5203L1.47693 7.2298C0.569129 6.75569 0 5.81638 0 4.79222V1.74951C0 0.783013 0.783502 -0.000488281 1.75 -0.000488281H18.25ZM10 11.5001C8.067 11.5001 6.5 13.0671 6.5 15.0001C6.5 16.9331 8.067 18.5001 10 18.5001C11.933 18.5001 13.5 16.9331 13.5 15.0001C13.5 13.0671 11.933 11.5001 10 11.5001ZM14 1.49951H5.997V7.89751L9.88427 9.92842C9.95678 9.96629 10.0432 9.96629 10.1157 9.92842L14 7.89851V1.49951Z" />
        </svg>
    ),
    displayName: 'RewardsFilled',
});

export default 'RewardsFilled';

registerIcons({
    icons: {
        RewardsFilled: <RewardsFilled />,
    },
});
